import { ActivatedRoute } from "@angular/router";
import { ROUTER_OUTLET_NAME } from "@modules/+new/shared/universal-modal/entities/magic";

export const getBottomRoute = (route: ActivatedRoute, targetOutlet = ROUTER_OUTLET_NAME): ActivatedRoute =>
	getChildRoute(route.root, targetOutlet);
export const getChildRoute = (route: ActivatedRoute, targetOutlet = ROUTER_OUTLET_NAME): ActivatedRoute => {
	const predicate = ({ outlet }): boolean => outlet === targetOutlet;
	const properChild = route.children.length > 1 ? route.children.find(predicate) : route.firstChild;
	return properChild ? getChildRoute(properChild, targetOutlet) : route;
};
